import GA_EVENTS from '../ga_constants';
import { setBehaviourEvent } from '../ga_interface';
import { Filters } from '../../../_flux/constants/filter/filters';
import formatCurrency from '../../currency/format_to_currency';
import PageTypeFactory from '../../../page/get_page_type';

function openMobileFilters() {
    const category = GA_EVENTS.catalogFiltersMobile.category;
    const action = GA_EVENTS.catalogFiltersMobile.actions.openMobileFilters;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function closeMobileFilters() {
    const category = GA_EVENTS.catalogFiltersMobile.category;
    const action = GA_EVENTS.catalogFiltersMobile.actions.closeMobileFilters;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function saveSectionFilters() {
    const category = GA_EVENTS.catalogFiltersMobile.category;
    const action = GA_EVENTS.catalogFiltersMobile.actions.saveSectionFilters;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}
function resetSectionFilters() {
    const category = GA_EVENTS.catalogFiltersMobile.category;
    const action = GA_EVENTS.catalogFiltersMobile.actions.resetSectionFilters;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}
function filterChange(filterName, filterValue, currencyIsoCode, mainObj) {
    const category = GA_EVENTS.catalogFiltersMobile.category;
    let label = filterValue || `All ${mainObj.label}`;

    if (filterName === Filters.PRICE_MIN || filterName === Filters.PRICE_MAX) {
        label = formatCurrency(filterValue, currencyIsoCode, true);
    }
    const action = GA_EVENTS.catalogFiltersMobile.actions.filterChange[filterName] || filterName;

    setBehaviourEvent({ category, action, label });
}
function unsetFilters(filterName) {
    const category = GA_EVENTS.catalogFiltersMobile.category;
    const action = GA_EVENTS.catalogFiltersMobile.actions.unsetFilters;

    setBehaviourEvent({ category, action, label: filterName });
}
function resetAllFiltersAndClose() {
    const category = GA_EVENTS.catalogFiltersMobile.category;
    const action = GA_EVENTS.catalogFiltersMobile.actions.resetAllFiltersAndClose;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}
function applyFilters() {
    const category = GA_EVENTS.catalogFiltersMobile.category;
    const action = GA_EVENTS.catalogFiltersMobile.actions.applyFilters;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label, beforeUnload: true });
}

function openSection(sectionName) {
    const category = GA_EVENTS.catalogFiltersMobile.category;
    const action = GA_EVENTS.catalogFiltersMobile.actions.openSection;

    setBehaviourEvent({ category, action, label: sectionName });
}

const CatalogMobileFiltersGoogleAnalytics = {
    openMobileFilters,
    closeMobileFilters,
    saveSectionFilters,
    resetSectionFilters,
    filterChange,
    unsetFilters,
    resetAllFiltersAndClose,
    applyFilters,
    openSection,
};

export { CatalogMobileFiltersGoogleAnalytics };